import type { ReactElement } from 'react';
import { genreGradient } from '../genres';
import type { GameCard } from '../types';

export type GameIconSize = 'sm' | 'md' | 'lg' | 'xl';

const PX: Record<GameIconSize, number> = { sm: 48, md: 64, lg: 96, xl: 128 };

/**
 * A game's icon, in the rounded-square app shape. A game without art gets its
 * first letter on its genre's colours instead of an empty box.
 */
export function GameIcon({
  game,
  size = 'md',
}: {
  game: Pick<GameCard, 'title' | 'iconUrl' | 'iconUrlLarge' | 'genres'>;
  size?: GameIconSize;
}): ReactElement {
  const px = PX[size];
  const src = px > 64 ? (game.iconUrlLarge ?? game.iconUrl) : game.iconUrl;
  if (!src) {
    return (
      <span
        className={`fg-icon fg-icon--${size} fg-icon--letter`}
        style={{ backgroundImage: genreGradient(game.genres[0] ?? '') }}
        aria-hidden="true"
      >
        {game.title.trim().charAt(0).toUpperCase() || '?'}
      </span>
    );
  }
  return (
    <span className={`fg-icon fg-icon--${size}`} aria-hidden="true">
      <img src={src} alt="" width={px} height={px} loading="lazy" decoding="async" />
    </span>
  );
}
